// LoginPage.tsx
import React, { useEffect, useState } from 'react';
import { Box, Spinner, Stack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/Logo_EssilorLuxottica_black.png';
import './LoginPage.css';
import { useAuth } from '../../context/AuthContext';

// IMPORTA la tua modale
import { PopupNudge } from '../../elements/PopupNudge';
// e l’helper per riconoscere l’errore
import { isPopupBlockedError } from '../../ServiceRequest';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, login, isLoadingAuth } = useAuth();
  const [showNudge, setShowNudge] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      const redirect = localStorage.getItem('redirect_uri');
      if (redirect) {
        localStorage.removeItem('redirect_uri');
        navigate(redirect);
      } else {
        navigate('/');
      }
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async () => {
    try {
      await login();
    } catch (e) {
      if (isPopupBlockedError(e)) {
        setShowNudge(true); // mostra la modale SOLO ora
        return;
      }
      console.error(e);
    }
  };

  return (
    <Box className="login-container">
      {/* Modale nudge: la apriamo solo se blocco popup */}
      {showNudge && <PopupNudge forceOpen size="lg" />}

      <Box className="login-box">
        <Stack align="center">
          <img className="logo" src={logo} alt="Logo" style={{ width: '350px', height: 'auto' }} />
          <h1 className="elwo-text">Document Editor</h1>

          {!isLoadingAuth ? (
            <button className="el-btn login-button" onClick={handleLogin}>
              Sign In
            </button>
          ) : (
            <Spinner thickness='4px' speed='0.65s' emptyColor='gray.200' color='black' size='xl' />
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export default LoginPage;
